/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';

/* Initial State */
const initialState = {};

/* Slice */
export const autocompleteSlice = createSlice({
  name: 'autocomplete',
  initialState,
  reducers: {
    updateOptions(state, action) {
      const { name, autocompleteOptions } = action.payload;
      state[name] = { ...state[name], autocompleteOptions };
    },
    updateSelectedOption(state, action) {
      const { name, response: selectedOption } = action.payload;
      state[name] = { ...state[name], selectedOption };
    },
  },
});

/* Selectors */
const selectAdapter = state => state[autocompleteSlice.name];
export const selectAutocompleteOptions = createSelector(
  state => selectAdapter(state),
  (state, name) => name,
  (state, name) => state[name]?.autocompleteOptions || [],
);
export const selectCurrentOption = createSelector(
  state => selectAdapter(state),
  (state, name) => name,
  (state, name) => state[name]?.selectedOption,
);
/* Actions */
export const { updateOptions, updateSelectedOption } = autocompleteSlice.actions;
